import { ReactElement } from 'react';
import clsx from 'clsx';

type Props = {
    icon?: any;
    iconClass?: string;
    title?: string;
    subtitle?: string;
    subtitleClass?: string;
    ctaLabel?: string;
    ctaOnClick?: () => void;
    children: ReactElement;
    cardClass?: string;
};

const Card = (props: Props): ReactElement => {
    const { icon, iconClass, title, subtitle, subtitleClass, ctaLabel, ctaOnClick, children, cardClass } =
        props;

    const clsxSubtitle = clsx('card-subtitle', subtitleClass);
    const clsxCard = clsx('card', cardClass && cardClass);

    return (
        <div className={clsxCard}>
            {!!icon && (
                <div
                    role="region"
                    aria-label="card icon"
                    className={`card-icon ${iconClass ?? ''}`}
                >
                    {icon}
                </div>
            )}
            {!!title && (
                <div role="region" aria-label="card title" className="card-title">
                    {title}
                </div>
            )}
            {!!subtitle && (
                <div role="region" aria-label="card subtitle" className={clsxSubtitle}>
                    {subtitle}
                </div>
            )}
            {children}
            {ctaLabel && ctaOnClick && (
                <div role="region" aria-label="card button" className="card-cta">
                    <button className="primary-button button-size-medium" onClick={ctaOnClick} data-element-id={'MyHub_' + ctaLabel.split(' ').join('')}>
                        {ctaLabel}
                    </button>
                </div>
            )}
        </div>
    );
};

export default Card;
